import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getCities, deleteCity } from '@/api/locations/cities';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import Enabled from '@/components/Enabled/index.vue';
import router from '@/router';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.isReadOnly = false;
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.stateId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      code: undefined,
      name: undefined,
      enabled: true,
      stateId: 0,
      sort: 'name,ASC',
      filter: {
        code: '$contL',
        name: '$contL',
        enabled: '$eq',
        stateId: '$eq'
      }
    };
    this.sortOptions = [{
      label: 'A-Z',
      key: 'name,ASC'
    }, {
      label: 'Z-A',
      key: 'name,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enabled'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  created() {
    this.stateId = parseInt(this.$route.params && this.$route.params.stateId);
    if (this.$route.query) {
      this.listQuery.name = this.$route.query.name || undefined;
      this.listQuery.enabled = this.$route.query.enabled || true;
      this.listQuery.code = this.$route.query.code || undefined;
      this.listQuery.sort = this.$route.query.sort || 'name,ASC';
    }
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery.stateId = this.stateId;
      const data = await getCities(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  handleDelete(data) {
    if (data) {
      this.$confirm(this.$tc('table.deleteConfirmation', undefined, {
        name: data.name
      }), this.$tc('table.delete'), {
        confirmButtonText: this.$tc('table.delete'),
        confirmButtonClass: 'el-button--danger',
        cancelButtonText: 'Cancel',
        type: 'error'
      }).then(() => {
        deleteCity(data.id).then(deleted => {
          this.getList();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$tc('table.deleteCanceled')
        });
      });
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['id', 'name', 'enabled', 'timestamp'];
    const filterVal = ['id', 'name', 'enabled', 'createdTimestamp'];
    const data = formatJson(filterVal, this.list);
    exportJson2Excel(tHeader, data, this.$tc('route.locations.cities.title'));
    this.downloadLoading = false;
  }
  edit(id = 0) {
    const query = this.listQuery;
    delete query.filter;
    router.push({
      path: '/cities/edit/' + id,
      query
    });
  }
};
default_1 = __decorate([Component({
  name: 'CityList',
  components: {
    Pagination,
    Enabled
  }
})], default_1);
export default default_1;